import Decimal from "decimal.js";
import { getProperty } from "dot-prop";
import {
  isDeductedTax,
  isTaxType,
  measurementUnit,
  MeasurementUnit,
  TaxType,
  taxType,
} from "~/mydata";

export const taxMeta = [
  {
    taxType: taxType.Withheld,
    taxCategory: 1,
    title: "Περιπτ. β’- Τόκοι - 15%",
    rate: 15,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 2,
    title: "Περιπτ. γ’ - Δικαιώματα - 20%",
    rate: 20,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 3,
    title: "Περιπτ. δ’ - Αμοιβές Συμβουλών Διοίκησης - 20%",
    rate: 20,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 4,
    title: "Περιπτ. δ’ - Τεχνικά Έργα - 3%",
    rate: 3,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 5,
    title: "Υγρά καύσιμα και προϊόντα καπνοβιομηχανίας 1%",
    rate: 1,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 6,
    title: "Λοιπά Αγαθά 4%",
    rate: 4,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 7,
    title: "Παροχή Υπηρεσιών 8%",
    rate: 8,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 8,
    title:
      "Προκαταβλητέος Φόρος Αρχιτεκτόνων και Μηχανικών επί Συμβατικών Αμοιβών, για Εκπόνηση Μελετών και Σχεδίων 4%",
    rate: 4,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 9,
    title:
      "Προκαταβλητέος Φόρος Αρχιτεκτόνων και Μηχανικών επί Συμβατικών Αμοιβών, που αφορούν οποιασδήποτε άλλης φύσης έργα 10%",
    rate: 10,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 10,
    title: "Προκαταβλητέος Φόρος στις Αμοιβές Δικηγόρων 15%",
    rate: 15,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 11,
    title: "Παρακράτηση Φόρου Μισθωτών Υπηρεσιών παρ. 1 αρ. 15 ν. 4172/2013",
    customAmount: true,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 12,
    title:
      "Παρακράτηση Φόρου Μισθωτών Υπηρεσιών παρ. 2 αρ. 15 ν. 4172/2013 - Αξιωματικών Εμπορικού Ναυτικού",
    rate: 15,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 13,
    title:
      "Παρακράτηση Φόρου Μισθωτών Υπηρεσιών παρ. 2 αρ. 15 ν. 4172/2013 - Κατώτερο Πλήρωμα Εμπορικού Ναυτικού",
    rate: 10,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 14,
    title: "Παρακράτηση Ειδικής Εισφοράς Αλληλεγγύης",
    customAmount: true,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 15,
    title:
      "Παρακράτηση Φόρου Αποζημίωσης λόγω Διακοπής Σχέσης Εργασίας παρ. 3 αρ. 15 ν. 4172/2013",
    customAmount: true,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 16,
    title:
      "Παρακρατήσεις συναλλαγών αλλοδαπής βάσει συμβάσεων αποφυγής διπλής φορολογίας (Σ.Α.Δ.Φ.)",
    customAmount: true,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 17,
    title: "Λοιπές Παρακρατήσεις Φόρου",
    customAmount: true,
  },
  {
    taxType: taxType.Withheld,
    taxCategory: 18,
    title: "Παρακράτηση Φόρου Μερίσματα περ.α παρ. 1 αρ. 64 ν. 4172/2013",
    rate: 5,
  },

  // {
  //   taxType: taxType.OtherTax,
  //   taxCategory: 2,
  //   title: "α1) ασφάλιστρα κλάδου πυρός 15%",
  //   rate: 15,
  //   deprecated: true,
  // },
  // {
  //   taxType: taxType.OtherTax,
  //   taxCategory: 2,
  //   title: "α2) ασφάλιστρα κλάδου πυρός 5%",
  //   rate: 5,
  //   deprecated: true,
  // },
  {
    taxType: taxType.OtherTax,
    taxCategory: 3,
    title: "β) ασφάλιστρα κλάδου ζωής 4%",
    rate: 4,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 4,
    title: "γ) ασφάλιστρα λοιπών κλάδων 15%.",
    rate: 15,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 5,
    title: "δ) απαλλασσόμενα φόρου ασφαλίστρων 0%.",
    rate: 0,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 6,
    title: "Ξενοδοχεία 1-2 αστέρων 0,50 €",
    amountPerItem: 0.5,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 7,
    title: "Ξενοδοχεία 3 αστέρων 1,50 €",
    amountPerItem: 1.5,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 8,
    title: "Ξενοδοχεία 4 αστέρων 3,00 €",
    amountPerItem: 3,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 9,
    title: "Ξενοδοχεία 5 αστέρων 4,00 €",
    amountPerItem: 4,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 10,
    title: "Ενοικιαζόμενα - επιπλωμένα δωμάτια - διαμερίσματα 0,50 €",
    amountPerItem: 0.5,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 11,
    title:
      "Ειδικός Φόρος στις διαφημίσεις που προβάλλονται από την τηλεόραση (ΕΦΤΔ) 5%",
    rate: 5,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 12,
    title:
      "3.1 Φόρος πολυτελείας 10% επί της φορολογητέας αξίας για τα ενδοκοινοτικώς αποκτούμενα και εισαγόμενα από τρίτες χώρες 10%",
    rate: 10,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 13,
    title:
      "3.2 Φόρος πολυτελείας 10% επί της τιμής πώλησης προ Φ.Π.Α. για τα εγχωρίως παραγόμενα είδη 10%",
    rate: 10,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 14,
    title:
      "Δικαίωμα του Δημοσίου στα εισιτήρια των καζίνο (80% επί του εισιτηρίου)",
    rate: 80,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 15,
    title: "ασφάλιστρα κλάδου πυρός 20%",
    rate: 20,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 16,
    title: "Λοιποί Τελωνειακοί Δασμοί-Φόροι",
    customAmount: true,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 17,
    title: "Λοιποί Φόροι",
    customAmount: true,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 18,
    title: "Επιβαρύνσεις Λοιπών Φόρων",
    customAmount: true,
  },
  {
    taxType: taxType.OtherTax,
    taxCategory: 19,
    title: "ΕΦΚ",
    customAmount: true,
  },

  {
    taxType: taxType.Fee,
    taxCategory: 1,
    title: "Για μηνιαίο λογαριασμό μέχρι και 50 ευρώ 12%",
    rate: 12.0,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 2,
    title: "Για μηνιαίο λογαριασμό από 50,01 μέχρι και 100 ευρώ 15%",
    rate: 15.0,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 3,
    title: "Για μηνιαίο λογαριασμό από 100,01 μέχρι και 150 ευρώ 18%",
    rate: 18.0,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 4,
    title: "Για μηνιαίο λογαριασμό από 150,01 ευρώ και άνω 20%",
    rate: 20.0,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 5,
    title: "Τέλος καρτοκινητής επί της αξίας του χρόνου ομιλίας (12%)",
    rate: 12.0,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 6,
    title: "Τέλος στη συνδρομητική τηλεόραση 10%",
    rate: 10.0,
  },

  {
    taxType: taxType.Fee,
    taxCategory: 7,
    title: "Τέλος συνδρομητών σταθερής τηλεφωνίας 5%",
    rate: 5.0,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 8,
    title:
      "Περιβαλλοντικό Τέλος & πλαστικής σακούλας ν. 2339/2001 αρ. 6α 0,07 ευρώ ανά τεμάχιο",
    amountPerItem: 0.07,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 9,
    title: "Εισφορά δακοκτονίας 2%",
    rate: 2.0,
  },

  {
    taxType: taxType.Fee,
    taxCategory: 10,
    title: "Λοιπά τέλη",
    customAmount: true,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 11,
    title: "Τέλη Λοιπών Φόρων",
    customAmount: true,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 12,
    title: "Εισφορά δακοκτονίας",
    customAmount: true,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 13,
    title: "Για μηνιαίο λογαριασμό κάθε σύνδεσης (10%)",
    rate: 10,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 14,
    title: "Τέλος καρτοκινητής επί της αξίας του χρόνου ομιλίας (10%)",
    rate: 10,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 15,
    title:
      "Τέλος κινητής και καρτοκινητής για φυσικά πρόσωπα ηλικίας 15 έως και 29 ετών (0%)",
    rate: 0,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 16,
    title:
      "Εισφορά προστασίας περιβάλλοντος πλαστικών προϊόντων 0,04 λεπτά ανά τεμάχιο [άρθρο 4 ν. 4736/2020]",
    amountPerItem: 0.04,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 17,
    title: "Τέλος ανακύκλωσης 0,08 λεπτά ανά τεμάχιο [άρθρο 80 ν. 4819/2021]",
    amountPerItem: 0.08,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 18,
    title: "Τέλος διαμονής παρεπιδημούντων",
    customAmount: true,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 19,
    title:
      "Tέλος επί των ακαθάριστων εσόδων των εστιατορίων και συναφών καταστημάτων",
    customAmount: true,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 20,
    title: "Τέλος επί των ακαθάριστων εσόδων των κέντρων διασκέδασης",
    customAmount: true,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 21,
    title: "Τέλος επί των ακαθάριστων εσόδων των καζίνο",
    customAmount: true,
  },
  {
    taxType: taxType.Fee,
    taxCategory: 22,
    title: "Λοιπά τέλη επί των ακαθάριστων εσόδων",
    customAmount: true,
  },
  {
    taxType: taxType.StampDuty,
    taxCategory: 1,
    title: "Συντελεστής Χαρτοσήμου 1,2 %",
    rate: 1.2,
  },
  {
    taxType: taxType.StampDuty,
    taxCategory: 2,
    title: "Συντελεστής Χαρτοσήμου 2,4 %",
    rate: 2.4,
  },
  {
    taxType: taxType.StampDuty,
    taxCategory: 3,
    title: "Συντελεστής Χαρτοσήμου 3,6 %",
    rate: 3.6,
  },
  {
    taxType: taxType.StampDuty,
    taxCategory: 4,
    title: "Λοιπές περιπτώσεις Χαρτοσήμου",
    customAmount: true,
  },
  {
    taxType: taxType.Deductions,
    customAmount: true,
    title: "Κρατήσεις",
    taxCategory: undefined,
  },
] as const;

export const findTax = (type: TaxType, category?: number) =>
  taxMeta.find((m) => m.taxType === type && m.taxCategory === category);
